import {
  field_background_theme,
  field_border_theme,
  field_color_theme,
} from 'framework/field/constants';
import { PillTheme } from 'framework/Pill/types';
import { font_theme } from 'framework/theme/constants/font';

export const pill_theme: Pick<PillTheme, 'general'> = {
  general: {
    font_family: font_theme.general.font_family,
    font_size: font_theme.general.font_size_small,
    padding: '0px 8px',
    border_radius: '3px', // outline messes up border radius
  },
};

export const pill_dark_theme: PillTheme = {
  general: pill_theme.general,
  background: field_background_theme,
  color: field_color_theme,
  border: field_border_theme,
};
